import { apiInstance, routes } from "../helpers/API";

class ResourceMonitoringService {
  /**
   * Get authorization header
   * @private
   */
  getAuthHeader() {
    return {
      Authorization: `Bearer ${localStorage.getItem("accessToken")?.replace(/"/g, "")}`,
    };
  }

  /**
   * Fetch calendar data for resource monitoring
   * @param {Object} params - Filter parameters
   * @returns {Promise} API response
   */
  async fetchCalendarData(params) {
    const {
      view = "month",
      projectId = null,
      shifts = [],
      taskId = null,
      scopeId = null,
      resources = [],
      capacity = [],
      startDate = null,
      endDate = null,
    } = params;

    let filter = "";

    if (projectId) {
      filter += `&ProjectId=${projectId}`;
    }

    if (shifts.length > 0) {
      filter += `&Shifts=${shifts.join(",")}`;
    }

    if (taskId) {
      filter += `&TaskId=${taskId}`;
    }

    if (scopeId) {
      filter += `&ScopeId=${scopeId}`;
    }

    if (resources.length > 0) {
      filter += `&Resources=${resources.join(",")}`;
    }

    if (capacity.length > 0) {
      filter += `&Capacity=${capacity.join(",")}`;
    }

    if (startDate && endDate) {
      filter += `&StartDate=${startDate}&endDate=${endDate}`;
    } else if (startDate) {
      filter += `&StartDate=${startDate}`;
    }

    const response = await apiInstance.get(
      `${routes.getResourceMonitering}?view=${view}${filter}`,
      {
        headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")?.replace(/"/g, "")}`,
    },
      }
    );

    return response.data;
  }

  /**
   * Fetch shifts list
   * @returns {Promise} API response with shifts
   */
  async fetchShiftsList() {
    const response = await apiInstance.get(routes.getShiftsList, {
      headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")?.replace(/"/g, "")}`,
    },
    });

    return response.data;
  }

  /**
   * Assign shift to resources
   * @param {Object} payload - Shift assignment data
   * @returns {Promise} API response
   */
  async assignShift(payload) {
    const response = await apiInstance.post(routes.assignShift, payload, {
      headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")?.replace(/"/g, "")}`,
    },
    });

    return response.data;
  }

  /**
   * Fetch tasks by resource ID
   * @param {string} resourceId - Resource identifier
   * @param {Object} params - Query parameters
   * @returns {Promise} API response
   */
  async fetchTasksByResourceId(resourceId, params) {
    const { view = "month", projectId =null, startDate = null, endDate = null } = params;

    let filter = "";

    if (projectId) {
      filter += `&projectId=${projectId}`;
    }

    if (startDate && endDate) {
      filter += `&startDate=${startDate}&endDate=${endDate}`;
    } else if (startDate) {
      filter += `&startDate=${startDate}&endDate=${startDate}`;
    }

    const response = await apiInstance.get(
      `${routes.getTasks.replace(":resourceId", resourceId)}?view=${view}${filter}`,
      {
        headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")?.replace(/"/g, "")}`,
    },
      }
    );

    return response.data;
  }

  /**
   * Create time off for resource
   * @param {Object} data - Time off data
   * @returns {Promise} API response
   */
  async createTimeOff(data) {
    const response = await apiInstance.post(routes.timeOff, data, {
      headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")?.replace(/"/g, "")}`,
    },
    });

    return response.data;
  }

  /**
   * Delete time off
   * @param {string} id - Time off identifier
   * @returns {Promise} API response
   */
  async deleteTimeOff(id) {
    const response = await apiInstance.delete(`${routes.timeOff}/${id}`, {
      headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")?.replace(/"/g, "")}`,
    },
    });

    return response.data;
  }

  /**
   * Delete shift
   * @param {string} id - Shift identifier
   * @returns {Promise} API response
   */
  async deleteShift(id) {
    const response = await apiInstance.delete(`${routes.getShiftsList}/${id}`, {
      headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")?.replace(/"/g, "")}`,
    },
    });

    return response.data;
  }

  /**
   * Update shift
   * @param {string} id - Shift identifier
   * @param {Object} data - Updated shift data
   * @returns {Promise} API response
   */
  async updateShift(id, data) {
    const response = await apiInstance.put(`${routes.getShiftsList}/${id}`, data, {
      headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")?.replace(/"/g, "")}`,
    },
    });

    return response.data;
  }
}

export default new ResourceMonitoringService();
